import { properties } from "@repoflow/common/schema-fields";

const { createdAt,
  updatedAt } = properties

export {
  createdAt,
  updatedAt
}

export const limitId = {
  label: "Limit Id",
  type: "string"
};
export const pointId = {
  label: "Point Id",
  type: "string"
};

export const description = {
  label: "Description",
  type: "string"
};

export const dimensions = {
  label: "Dimensions",
  type: "array",
  items: {
    type: "string"
  },
  default: [],
}

export const limits = {
  label: "Limits",
  type: "array",
  items: {
    type: "object",
    properties: {
      measure: {
        type: "string",
        default: "",
        minLength: 1
      },
      type: {
        type: "string",
        widget: "select",
        enum: [
          "less-than",
          "greater-than",
          "different"
        ],
        minLength: 1
      },
      period: {
        type: "string",
        widget: "select",
        enum: [
          "annually",
          "monthly",
          "weekly",
          "daily"
        ],
        minLength: 1
      }
    },
    required: ["type"]
  },
  index: "uuid",
  default: [],
}
/*

id: "/Paragraph",
    type: "object",
    patternProperties: {
      "^[a-z]{2}-[A-Z]{2}$": {
        type: "string"
      }
    },
    default: {}

*/














